import { PageProvider } from '@/core/context/PageContext';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { useTableFilter } from '@/core/hooks/useTableFilter';
import { GetDetailCourseLine, GetListCourseLine } from '../viewmodels';

export const CourseLineProvider = (props: any) => {
  const {
    courseLineData: detailCourseLine,
    actionGetDetailCourseLine,
    loading: loadingDetail,
    error: errorDetail,
  } = GetDetailCourseLine();

  const { courseLineData, actionGetAllCourseLine, loading, error } = GetListCourseLine();

  const [currentQueryParameters] = useSearchParams();
  const getId = currentQueryParameters.get('id');

  const { methodFilter } = useTableFilter({
    handleFetchData: actionGetAllCourseLine,
    querySearch: { search: '' },
    queryFilters: { isActive: undefined },
    queryPagination: { page: 1, limit: 10 },
  });

  const { control, setValue, reset, getValues, watch } = methodFilter;

  useEffect(() => {
    actionGetAllCourseLine(getValues());
  }, []);

  useEffect(() => {
    if (getId) {
      actionGetDetailCourseLine(getId);
    }
  }, [getId]);

  const data = {
    detailCourseLine,
    actionGetDetailCourseLine,
    loadingDetail,
    errorDetail,
    courseLineData,
    actionGetAllCourseLine,
    loading,
    error,
    control,
    setValue,
    reset,
    getValues,
    watch,
  };

  return <PageProvider {...data}>{props.children}</PageProvider>;
};
